import { DPIDValues, SeparateHazardousActivities } from './types';

export const HAZARDOUS_ACTIVITIES_URNS: Array<keyof SeparateHazardousActivities> = [
  'urn:pg:data-point:insured-risk-activity-aeronautics',
  'urn:pg:data-point:insured-risk-activity-aviation',
  'urn:pg:data-point:insured-risk-activity-base-jumping',
  'urn:pg:data-point:insured-risk-activity-extreme-motorsports',
  'urn:pg:data-point:insured-risk-activity-motor-sports',
  'urn:pg:data-point:insured-risk-activity-rock-climbing',
  'urn:pg:data-point:insured-risk-activity-rodeos',
  'urn:pg:data-point:insured-risk-activity-scuba-diving',
  'urn:pg:data-point:insured-risk-activity-snowsports',
  'urn:pg:data-point:insured-risk-activity-ultralight-flying',
];

export const INTERVIEW_URNS: Array<keyof DPIDValues> = [
  ...HAZARDOUS_ACTIVITIES_URNS,
  'urn:pg:data-point:insured-risk-activity-description',
];
